// ── All Terms — global list of loan terms ──
import { useState, useEffect } from "react";
import { localFilter, exportCSV, fmt, fmtRatio, fmtDate } from "../../../shared/format";
import { Spinner, ErrorMsg, SectionHeader, SearchBar, Btn, Card, STh, Th, Td, TdNum, Badge, Icon } from "../../../shared/ui";
import { useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const AllTermsPage = () => {
    const { api, setModal, role, setConfirm, delRec } = useApp();
    const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null);
    const [q,setQ]=useState("");
    const load=()=>{setLoading(true);api.get("getTerms").then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
    useEffect(()=>{load();},[]);
    const filtered=localFilter(rows,q,["loannumber","LoanNumber","companyname","pipelinestage","facility_type","term_type","collateraltype"]);
    const { sorted:displayed, sortKey, sortDir, toggle } = useSortable(filtered, 'loannumber');

    if(loading) return <Spinner />; if(err) return <ErrorMsg msg={err} onRetry={load} />;
    return <>
      <SectionHeader actions={[
        <SearchBar key="s" value={q} onChange={setQ} placeholder="Search terms..." />,
        <Btn key="ex" onClick={()=>exportCSV(filtered,["loannumber","facility_type","term_type","commitment","fundingamount","margin","fundingdate","pipelinestage"],"terms.csv")}>Export CSV</Btn>
      ]} />
        <Card><table style={{ width:"100%",borderCollapse:"collapse" }}>
          <thead><tr>
          <STh label="Loan #"       sortKey="loannumber"   currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Collateral" sortKey="collateraltype" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Facility Type" sortKey="facility_type" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Term Type"    sortKey="term_type"    currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Commitment"   sortKey="commitment"   currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
          <STh label="Funding Amt"  sortKey="fundingamount" currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
          <STh label="Margin"       sortKey="margin"       currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
          <STh label="Funding Date" sortKey="fundingdate"  currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <STh label="Stage"        sortKey="pipelinestage" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
          <Th></Th>
        </tr></thead>

        <tbody>{displayed.map(t=>(<tr key={t.id} style={{ cursor:"pointer" }} onClick={()=>setModal({type:"terms-view",rec:{...t,id:t.id,loanid:t.loanid}})} onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
          <Td><span style={{ fontFamily:"var(--font-mono)",fontSize:12 }}>{t.loannumber}</span></Td>
          <Td>{t.collateraltype||"—"}</Td>
          <Td>{t.facility_type}</Td>
          <Td>{t.term_type}</Td>
          <TdNum>{fmt(t.commitment)}</TdNum>
          <TdNum>{fmt(t.fundingamount)}</TdNum>
          <TdNum>{fmtRatio(t.margin)}</TdNum>
          <Td>{fmtDate(t.fundingdate)}</Td>
          <Td><Badge s={t.pipelinestage} /></Td>
          <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={e=>e.stopPropagation()}>
            <Btn onClick={()=>setModal({type:"terms-view",rec:{...t,id:t.id,loanid:t.loanid}})}><Icon type="view" /></Btn>
            {role.canEdit&&<Btn onClick={()=>setModal({type:"terms-edit",rec:{...t,id:t.id,loanid:t.loanid},onDone:load})}><Icon type="edit" /></Btn>}
            {role.canDelete&&<Btn onClick={()=>setConfirm({msg:"Delete these terms?",onConfirm:()=>delRec("Terms",t.id,"Deleted terms",load)})} variant="danger"><Icon type="delete" /></Btn>}
          </div></Td>
        </tr>))}</tbody>
      </table></Card>
    </>;
  };
